<template>
    <v-container grid-list-sm text-xs-left>
        <v-layout row wrap :class="{ 'pa-2': !isMobile() }">
            <v-flex xs12>
                <font size="7">
                    Try it out
                </font>
            </v-flex>
            <v-flex xs12 py-2>
                <PluginsList type="plugins"></PluginsList>
            </v-flex>
            <v-flex xs12>
                <PluginsList class="pt-3" type="functions"></PluginsList>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import PluginsList from "@/components/Lists/PluginsList";

    export default {
        name: "PluginsListTraining",
        components: {PluginsList},
        data() {
            return {

            };
        },
        methods: {
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
        },
    };
</script>

<style lang="scss">

</style>
